import state from './state'
import getters from './getters'
import actions from './actions'
import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user/index'
import auth from './modules/auth/index'
import service from './modules/service/index'
import billing from './modules/billing/index'
Vue.use(Vuex)

export default new Vuex.Store({
  state: state,

  getters: getters,

  mutations: {
    set(state, [key, value]) {
      // This is our single state setter. It avoids the unnecessary code duplication of
      // creating a mutation for every item in state.
      state[key] = value
    }
  },

  actions: actions,

  modules: {
    user,
    auth,
    service,
    billing
  }
})
